export enum CompanyType {
  GROCER = 1,
  RETAILER = 2,
  RESTAURANT = 3,
  OTHER = 4,
  POSTAL = 5,
  BUSINESS_SERVICE = 6,
  CONVIENCE_STORE = 7,
  COMMUNITY = 8,
  HEALTHCARE = 9,
  COMMERCIAL_REAL_ESTATE = 11,
  HOTEL = 12,
  MARRIOTT = 100,
  NOT_SPECIFIED = 255,
}
